import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
interface PurchaseSectionProps {
  id?: string;
}
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-10 bg-brand-dark" data-id="element-161">
      {/* Urgency strip */}
      <div className="bg-brand-cardAlt py-5 px-4 text-center border-y border-brand-danger/20" data-id="element-162">
        <p className="text-brand-danger font-bold text-sm mb-2" data-id="element-163">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </p>
        <CountdownTimer className="!text-brand-danger [&_div]:!border-brand-danger/20 [&_div]:!bg-brand-card [&_span]:!text-brand-danger/60 !text-2xl md:!text-3xl mb-2" data-id="element-164" />
        <p className="text-brand-text font-bold text-xs mb-3" data-id="element-165">
          Después sube el precio y no vuelve a bajar.
        </p>
        <div className="max-w-xs mx-auto" data-id="element-166">
          <p className="text-xs font-bold text-brand-text mb-1 text-left" data-id="element-167">
            📊 Cupos al precio de lanzamiento — 78% tomados
          </p>
          <div className="w-full bg-black/5 rounded-full h-2 overflow-hidden" data-id="element-168">
            <div className="bg-brand-danger h-2 rounded-full w-[78%]" data-id="element-169"></div>
          </div>
        </div>
      </div>

      {/* Offer */}
      <div className="py-8 md:py-12 px-4" data-id="element-170">
        <div className="max-w-xl mx-auto" data-id="element-171">
          <div className="bg-brand-card rounded border border-black/10 p-6 md:p-8 text-center shadow-sm" data-id="element-172">
            <p className="text-sm font-bold text-brand-accent mb-2" data-id="element-173">
              🏆 OFERTA ÚNICA
            </p>
            <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-text mb-4" data-id="element-174">
              KIT COMPLETO FILOSOFÍA LISTA
            </h3>
            <p className="text-sm md:text-base text-brand-text mb-6" data-id="element-175">
              Los 6 tomos + 4 bonos estratégicos + Actualizaciones de por vida
            </p>

            <div className="mb-6" data-id="element-176">
              <span className="text-base text-brand-text/50 line-through mr-2" data-id="element-177">
                USD 45.00
              </span>
              <span className="text-3xl md:text-4xl font-bold text-brand-gold" data-id="element-178">
                Hoy: USD 19,90
              </span>
            </div>

            <Button href="https://filosofia.impultienda.ar/checkout" className="w-full mb-4" data-id="element-179">
              📜 → QUIERO EL KIT COMPLETO
            </Button>

            <p className="text-xs text-brand-text/70 mb-4 leading-relaxed" data-id="element-180">
              El precio está en dólares estadounidenses (USD). El cobro se
              realiza automáticamente en la moneda de tu país al tipo de cambio
              del momento.
            </p>

            <div className="text-xs font-bold text-brand-text/80 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-181">
              <span data-id="element-182">🔒 Pago seguro</span>
              <span data-id="element-183">⚡ Acceso en 5 min</span>
              <span data-id="element-184">🛡️ Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}